import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { resetTenantLocalData } from '@/db/reset';

interface ImpersonatedTenant {
  id: string;
  slug: string;
  name: string;
}

interface ImpersonationState {
  tenant: ImpersonatedTenant | null;
  /** Platform admin picks a tenant from /super/tenants to operate it directly. */
  enter: (t: ImpersonatedTenant) => void;
  /** Back to the platform-wide view. */
  exit: () => void;
}

// Separate persisted store from authStore — impersonation is a platform-admin-
// only overlay on top of a real session, not part of the login identity.
export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      tenant: null,
      enter: (t) => {
        resetTenantLocalData().catch(() => {});
        set({ tenant: t });
      },
      exit: () => {
        resetTenantLocalData().catch(() => {});
        set({ tenant: null });
      },
    }),
    {
      name: 'ofi-cia-impersonation',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
